<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>로켓머니</h3>
				<h4>사업자 로켓머니 혜택 및 안내</h4>
			</div>
			<div class="about mb50">
				<div class="title mb20">사업자 로켓머니란?</div>
				<p>
					일정금액을 충전하신 후<br>
					구매대행 상품비용, 배송비용, 부가서비스 비용(일부) 등을<br>
					결제 시 간단하게 이용하실 수 있는 <strong>예치금 형태의 서비스</strong>입니다.
				</p>
			</div>
			
			<div class="charge">
				<div class="content">
					<h5>
						충전금액의
						1% 추가적립
					</h5>
					
					<div class="pay_btn" @click="onCybercash">충전하기</div>
				</div>
			</div>
			
			<div class="unit">
				<h6>로켓머니 이용규정</h6>
				<ul class="check-list">
					<li>로켓머니는 구매대행 상품값, 국제배송비 결제 시 사용가능합니다.</li>
					<li>로켓머니는 고로켓고의 서비스 내에서만 사용할 수 있는 전자화폐이며, 계정 소멸 전까지 보관됩니다.</li>
					<li>로켓머니는 회원의 각종 할인혜택과 함께 제한없이 사용하실 수 있습니다.</li>
					<li>충전된 로켓머니는 마이페이지 내의 나의 로켓머니 내역에서 확인하실 수 있습니다.</li>
					<li>로켓머니는 가상계좌 결제로 구매가능하시며 신용카드 결제 시 3%로의 카드 수수료가 발생합니다.</li>
					<li>충전된 로켓머니 환불 요청 시 가상계좌로 결제하셨을 경우 3영업일 이내 잔액의 3% 수수료를 공제 후 환불하여 드립니다.</li>
					<li>충전된 로켓머니 환불요청시 해당 로켓머니의 구매로 인하여 적립지급된 보너스머니는 전량회수되며 이미 사용하셨을 경우에는 환불금에서 공제합니다.</li>
					<li>충전된 로켓머니는 충전된 계정 내에서만 사용가능합니다.</li>
					<li>충전하신 로켓머니는 충전한 계정 내에서만 사용가능하며 타 계정으로 이전이 불가능합니다.</li>
				</ul>	
			</div>
			
			
		</div>
		
		<el-dialog title="로켓머니 충전 신청" :visible.sync="rechargeVisible" :close-on-click-modal="false" :close-on-press-escape="false" :width="isMobile?'90%':'500px'">
			<div class="bank-info" style="background:#f5f8fd; padding:15px; border-radius:10px; margin-bottom:20px;">
				<h4 style="margin-top:0; color:#0055d4;">무통장 입금 계좌</h4>
				<div style="font-size:14px; line-height:1.8;">
					<strong>은행명:</strong> 국민은행<br>
					<strong>계좌번호:</strong> 1234-5678-9012<br>
					<strong>예금주:</strong> (주)고로켓고
				</div>
			</div>
			<el-form :model="rechargeForm" label-width="120px">
				<el-form-item label="충전금액(원)" required>
					<el-input v-model="rechargeForm.amount" type="number" placeholder="입금하신 금액을 입력하세요"></el-input>
				</el-form-item>
				<el-form-item label="입금자 성명" required>
					<el-input v-model="rechargeForm.remitter_name" placeholder="실제 입금자명을 입력하세요"></el-input>
				</el-form-item>
				<el-form-item label="입금일자" required>
					<el-date-picker v-model="rechargeForm.remittance_date" type="date" placeholder="입금일자 선택" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>
					<el-form-item label="회원번호" required>
					<el-input v-model="rechargeForm.post_id" placeholder="회원 고유번호를 입력하세요"></el-input>
				</el-form-item>
				<el-form-item label="입금증명서" required>
			  		<el-upload
			  		  class="avatar-uploader"
			  		  :action="update_url+'/common/upload'"
			  		  :show-file-list="false"
			  		  :on-success="handleVoucherSuccess"
			  		  :before-upload="beforeVoucherUpload">
						 <el-image v-if="rechargeForm.voucherUrl"
						      class="avatar" style="width:100px; height:100px; display:block;"
						      :src="rechargeForm.voucherUrl"
						      fit="cover"></el-image>
					   <el-button v-else size="small" plain type="primary">이미지 업로드</el-button>
			  		</el-upload>
				</el-form-item>
				<div style="color:#F56C6C; font-size:13px;padding:0 10px;">※ 평일 8:30~17:30에는 보통 30분 이내에 신속하게 심사 처리되며, 휴일에는 처리 시간이 다소 소요될 수 있으니 양해 부탁드립니다.</div>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="rechargeVisible = false">취소</el-button>
				<el-button type="primary" @click="submitRecharge">신청하기</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import request from '@/utils/request'
	import Constants from "@/constants";
	export default {
		components: {
			BusinessBanner
		},
		data() {
			return{
				SERVER_URL: Constants.SERVER_URL,
				update_url: Constants.BASE_URL,
				rechargeVisible: false,
				rechargeForm: {
					post_id: '',
					amount: '',
					remitter_name: '',
					remittance_date: '',
					voucher_image: '',
					voucherUrl: ''
				},
			}
		},
		computed: {
			isMobile() {
				return window.innerWidth <= 768;
			}
		},
		methods: {
			onCybercash(e){
				if(e) e.preventDefault();
				this.rechargeVisible = true;
				this.rechargeForm = {
					post_id: '',
					amount: '',
					remitter_name: '',
					remittance_date: '',
					voucher_image: '',
					voucherUrl: ''
				};
			},
			handleVoucherSuccess(res, file) {
				if(res.code == 1) {
					this.rechargeForm.voucherUrl = res.data.fullurl;
					this.rechargeForm.voucher_image = res.data.url;
				} else {
					this.$message.error(res.msg || "업로드 실패");
				}
			},
			beforeVoucherUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
				  this.$message.error('업로드 이미지는 JPG 또는 PNG 형식이어야 합니다!');
				  return false;
				}
				if (!isLt5M) {
				  this.$message.error('업로드 이미지 크기는 5MB를 초과할 수 없습니다!');
				  return false;
				}
				return true;
			},
			submitRecharge() {
				if(!this.rechargeForm.post_id) {
					this.$message.error("회원번호를 입력하세요."); return;
				}
				if(!this.rechargeForm.amount) {
					this.$message.error("충전금액을 입력하세요."); return;
				}
				if(!this.rechargeForm.remitter_name) {
					this.$message.error("입금자명을 입력하세요."); return;
				}
				if(!this.rechargeForm.remittance_date) {
					this.$message.error("입금일자를 선택하세요."); return;
				}
				if(!this.rechargeForm.voucher_image) {
					this.$message.error("입금증명서를 업로드하세요."); return;
				}
				request.post('/member/Cybercash/apply', this.rechargeForm).then(res => {
					if(res.code == 1) {
						this.$message.success("충전 신청이 완료되었습니다. 관리자 확인 후 처리됩니다.");
						this.rechargeVisible = false;
					} else {
						this.$message.error(res.msg || "신청에 실패했습니다.");
					}
				});
			},
		}		
		
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--main-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
	}
	.about {
	    text-align: center;
	}
	.about .title {
	    font-weight: 700;
	    font-size: 24px;
	    line-height: 29px;
	    color: var(--frontground-color);
	}
	.charge {
	    border: 1px solid #DEDEDE;
	    border-radius: 30px;
		display: flex;
		justify-content: center;
		padding: 30px 0;
		margin: 0 auto;
		width: 500px;
	}
	.charge .content h5 {
	    font-weight: 700;
	    font-size: 24px;
	    line-height: 150%;
	    color: var(--secondary-color);
	    margin: 0 0 20px;
	}
	.pay_btn{
		width: 160px;
		line-height: 55px;
		background: #F00000;
		border-radius: 50px;
		text-align: center;
		font-weight: 800;
		font-size: 20px;
		color: #fff;
		margin: 0 auto;
		padding: 0 auto;
		cursor: pointer;
	}
	.unit{
		width: 768px;
		margin:0 auto 30px;
	}
	.unit h6 {
	    font-weight: 700;
	    font-size: 20px;
	    line-height: 24px;
	    color: #111111;
	    margin: 0 0 20px;
		margin-top: 50px;
	}
	ul.check-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	}
	ul.check-list li {
	    padding-left: 26px;
	    background: url('../../assets/ico_check_grey.svg') no-repeat left 2px top 4px;
	    font-weight: 400;
	    font-size: 15px;
	    line-height: 23px;
	}
	
	
	
	.mb20 {
	    margin-bottom: 20px !important;
	}
	.mb50 {
	    margin-bottom: 50px !important;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	
	@media (max-width: 768px) {
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.charge {
		    border: 1px solid #DEDEDE;
		    border-radius: 30px;
			display: flex;
			justify-content: center;
			padding: 30px 0;
			margin: 0 auto;
			width: 90%;
		}
		.unit{
			width: 90%;
		}
		
	
	}
</style>